// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__P4iIT","img":"menu_img__F+HaL"};